export enum HingeType {
  CadHinge = 'cad-hinge',
  None = 'none',
}
